export default "__VITE_ASSET__ClqqtSqV__"